import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {ITestKitOrderResume, TestKitOrderResume} from '../TestKitOrder.ts';
import {TestKitOrderApi} from '../../../apis/TestKitOrderApi/TestKitOrderApi.ts';
import {useHighFrequencyRefreshQuery} from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery.tsx';

export function useGetTestKitOrders() {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.testKitOrderResume],
        queryFn: async () => {
            const result: ITestKitOrderResume[] = await TestKitOrderApi.getTestKitOrders();
            return result ? result.map((x) => new TestKitOrderResume(x)) : result;

        },
    });
}